import React, { FC, useState } from 'react';
import { createUseStyles } from '../../../../../../theming';
import 'react-vertical-timeline-component/style.min.css';
import { Grid, LinearProgress } from '@material-ui/core';
import { Item, ItemType } from '../../../../../../interfaces/api/ActivityWall';
import clsx from 'clsx';
import Button from '../../../../../../components/Button';
import Timeline from './components/Timeline/Timeline';
import EventTypePicker from './components/EventTypePicker';
import CommentCard from './components/CommentCard';
import DateFilter from './components/DateFilter';
import { Order } from 'src/interfaces/Table';
import SearchBar from './components/SearchBar';
import Hidden from '../../../../../components/Hidden';

interface Props {
  items: Item[];
  className?: string;
  typeFilter?: ItemType;
  onTypeFilterChange: (typeFilter?: ItemType) => void;
  onChangeSearchString: (searchString: string) => void;
  onDateFilterChange: (startDate: string | null, endDate: string | null, order: Order) => void;
  startDateFilter: string | null;
  endDateFilter: string | null;
  loading?: boolean;
  order: Order;
  wallId: string;
  search?: string;
}

const useStyles = createUseStyles({
  root: {
    overflow: 'hidden',
    padding: 16,
  },
  searchInput: {
    width: '100%',
    marginRight: 10,
  },
  actionContainer: {
    background: '#ececec',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
  },
  leftContainer: {
    display: 'flex',
  },
  rightContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  commentButton: {
    marginLeft: '10px !important',
  },
});

const WallCard: FC<Props> = ({
  items,
  startDateFilter,
  endDateFilter,
  order,
  search,
  loading,
  onDateFilterChange,
  onTypeFilterChange,
  typeFilter,
  onChangeSearchString,
  className,
  wallId,
  ...props
}) => {
  const [commentCardOpen, setCommentCardOpen] = useState(false);
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...props}>
      <Grid container className={classes.actionContainer} spacing={1}>
        <Grid item md={4} xs={12} className={classes.leftContainer}>
          <SearchBar className={classes.searchInput} onChange={onChangeSearchString} />
          <DateFilter endDate={endDateFilter} startDate={startDateFilter} order={order} onChange={onDateFilterChange} />
        </Grid>

        <Grid item md={8} xs={12} className={classes.rightContainer}>
          <Hidden smDown>
            <EventTypePicker onChange={onTypeFilterChange} value={typeFilter} />
          </Hidden>

          <Button
            color='primary'
            variant='contained'
            className={classes.commentButton}
            onClick={() => setCommentCardOpen(!commentCardOpen)}
          >
            {commentCardOpen ? 'Fermer' : 'Commenter'}
          </Button>
        </Grid>
      </Grid>
      {loading && <LinearProgress />}

      <CommentCard wallId={wallId} open={commentCardOpen} onClose={() => setCommentCardOpen(false)} />

      <Timeline wallId={wallId} items={items} order={order} />
    </div>
  );
};

export default WallCard;
